import React, { useState, useEffect, useCallback } from "react";

const Portfolio = ({ data }) => {
  const [lightboxProject, setLightboxProject] = useState(null);

  const closeLightbox = useCallback(() => setLightboxProject(null), []);

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") closeLightbox();
    };
    if (lightboxProject) {
      document.addEventListener("keydown", handleKey);
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.removeEventListener("keydown", handleKey);
      document.body.style.overflow = "";
    };
  }, [lightboxProject, closeLightbox]);

  if (!data || !data.projects) return null;

  const projects = data.projects.map((project) => {
    const projectImage = "images/portfolio/" + project.image;

    return (
      <div key={project.title} className="pf-card">
        <div className="pf-card__image-wrap">
          <img
            className="pf-card__image"
            src={projectImage}
            alt={project.title}
          />

          <div className="pf-card__overlay">
            <div className="pf-card__overlay-content">
              {project.tags && (
                <div className="pf-card__tags">
                  {project.tags.map((tag) => (
                    <span key={tag} className="pf-card__tag">
                      {tag}
                    </span>
                  ))}
                </div>
              )}
              <div className="pf-card__actions">
                <a
                  href={project.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="pf-card__btn pf-card__btn--primary"
                  onClick={(e) => e.stopPropagation()}
                >
                  <i className="fa fa-external-link"></i> Live Demo
                </a>
                {project.github && (
                  <a
                    href={project.github}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="pf-card__btn pf-card__btn--secondary"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <i className="fa fa-github"></i> View Code
                  </a>
                )}
              </div>
            </div>
          </div>

          <button
            className="pf-card__expand"
            onClick={() => setLightboxProject(project)}
            aria-label={`Open ${project.title} preview`}
          >
            <i className="fa fa-expand"></i>
          </button>
        </div>

        <div className="pf-card__info">
          <h5 className="pf-card__title">{project.title}</h5>
          {project.description && (
            <p className="pf-card__desc">{project.description}</p>
          )}
        </div>
      </div>
    );
  });

  return (
    <section id="portfolio">
      <div className="row">
        <div className="twelve columns">
          <h1>Check Out Some of My Works.</h1>
        </div>
      </div>

      <div className="pf-grid">{projects}</div>

      {lightboxProject && (
        <div className="pf-lightbox" onClick={closeLightbox}>
          <div
            className="pf-lightbox__content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="pf-lightbox__close"
              onClick={closeLightbox}
              aria-label="Close preview"
            >
              <i className="fa fa-times"></i>
            </button>

            <div className="pf-lightbox__image-wrap">
              <img
                className="pf-lightbox__image"
                src={"images/portfolio/" + lightboxProject.image}
                alt={lightboxProject.title}
              />
            </div>

            <div className="pf-lightbox__details">
              <h3 className="pf-lightbox__title">{lightboxProject.title}</h3>
              {lightboxProject.description && (
                <p className="pf-lightbox__desc">
                  {lightboxProject.description}
                </p>
              )}
              {lightboxProject.tags && (
                <div className="pf-lightbox__tags">
                  {lightboxProject.tags.map((tag) => (
                    <span key={tag} className="pf-card__tag">
                      {tag}
                    </span>
                  ))}
                </div>
              )}
              <div className="pf-lightbox__actions">
                <a
                  href={lightboxProject.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="pf-card__btn pf-card__btn--primary"
                >
                  <i className="fa fa-external-link"></i> Live Demo
                </a>
                {lightboxProject.github && (
                  <a
                    href={lightboxProject.github}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="pf-card__btn pf-card__btn--secondary"
                  >
                    <i className="fa fa-github"></i> View Code
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Portfolio;
